export interface Token {
  symbol: string;
  name: string;
  decimals: number;
  address: `0x${string}`;
}

interface TokenMap {
  [chain: string]: {
    [symbol: string]: Token;
  };
}

export const TOKENS = {
  ETHEREUM: {
    WETH: {
      symbol: 'WETH',
      name: 'Wrapped Ether',
      address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
      decimals: 18,
    },
    WBTC: {
      symbol: 'WBTC',
      name: 'Wrapped BTC',
      address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
      decimals: 8,
    },
  },
  ARBITRUM: {
    USDC: {
      symbol: 'USDC',
      name: 'USD Coin',
      address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
      decimals: 6,
    },
    USDT: {
      symbol: 'USDT',
      name: 'Tether USD',
      address: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
      decimals: 6,
    },
    WETH: {
      symbol: 'WETH',
      name: 'Wrapped Ether',
      address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
      decimals: 18,
    },
    WBTC: {
      symbol: 'WBTC',
      name: 'Wrapped BTC',
      address: '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f',
      decimals: 8,
    },
  },
  OPTIMISM: {
    WETH: {
      symbol: 'WETH',
      name: 'Wrapped Ether',
      address: '0x4200000000000000000000000000000000000006',
      decimals: 18,
    },
    WBTC: {
      symbol: 'WBTC',
      name: 'Wrapped BTC',
      address: '0x68f180fcCe6836688e9084f035309E29Bf0A2095',
      decimals: 8,
    },
  },
  POLYGON: {
    WPOL: {
      symbol: 'WPOL',
      name: 'Wrapped POL',
      address: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
      decimals: 18,
    },
    WETH: {
      symbol: 'WETH',
      name: 'Wrapped Ether',
      address: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
      decimals: 18,
    },
    WBTC: {
      symbol: 'WBTC',
      name: 'Wrapped BTC',
      address: '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
      decimals: 8,
    },
  },
  BNB: {
    WBNB: {
      symbol: 'WBNB',
      name: 'Wrapped BNB',
      address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      decimals: 18,
    },
    BTCB: {
      symbol: 'BTCB',
      name: 'BTCB Token',
      address: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
      decimals: 18,
    },
    USDC: {
      symbol: 'USDC',
      name: 'USDC',
      address: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
      decimals: 18,
    },
    USDT: {
      symbol: 'USDT',
      name: 'USDT',
      address: '0x55d398326f99059fF775485246999027B3197955',
      decimals: 18,
    },
    XAUt: {
      symbol: 'XAUt',
      name: 'Tether Gold',
      address: '0x21cAef8A43163Eea865baeE23b9C2E327696A3bf',
      decimals: 6,
    },
  },
  BASE_L2: {
    USDC: {
      symbol: 'USDC',
      name: 'USDC',
      address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
      decimals: 6,
    },
    USDT: {
      symbol: 'USDT',
      name: 'USDT',
      address: '0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2',
      decimals: 6,
    },
    WETH: {
      symbol: 'WETH',
      name: 'WETH',
      address: '0x4200000000000000000000000000000000000006',
      decimals: 18,
    },
    cbBTC: {
      symbol: 'cbBTC',
      name: 'cbBTC',
      address: '0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf',
      decimals: 8,
    },
    EURC: {
      symbol: 'EURC',
      name: 'EURC',
      address: '0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42',
      decimals: 6,
    },
  },
} as const satisfies TokenMap;
